import { TemplateTypeComponent } from './template-type.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { CastObservablePipe } from '@lockton-apps/shared/ui/pipes';
import { RouterLink } from '@angular/router';
import { LinkDirective, RoutedLabelModule } from '@lockton-apps/shared/ui/lui';

@NgModule({
  declarations: [TemplateTypeComponent],
  imports: [
    CommonModule,
    CastObservablePipe,
    FormlyModule.forChild({
      types: [
        {
          name: 'template',
          component: TemplateTypeComponent,
          wrappers: ['addons'],
          defaultOptions: {
            key: 'template',
            className: 'd-block mb-2',
          },
        },
      ],
    }),
    RouterLink,
    LinkDirective,
    RoutedLabelModule,
  ],
})
export class TemplateTypeModule {}
